import api from './api';

export const getMyDeclaration = async (financialYear) => {
    const response = await api.get(`/tax/declaration?financial_year=${financialYear}`);
    return response.data;
};

export const submitDeclaration = async (data) => {
    const response = await api.post('/tax/declaration', data);
    return response.data;
};

export const getTaxSettings = async () => {
    const response = await api.get('/tax/settings');
    return response.data;
};

export const updateTaxSettings = async (data) => {
    const response = await api.post('/tax/settings', data);
    return response.data;
};

export const getAllDeclarations = async (financialYear) => {
    const response = await api.get(`/tax/declarations?financial_year=${financialYear}`);
    return response.data;
};

export const verifyDeclaration = async (declarationId, data) => {
    const response = await api.post(`/tax/declarations/${declarationId}/verify`, data);
    return response.data;
};

export const getTaxComparison = async (financialYear) => {
    const response = await api.get(`/tax/comparison?financial_year=${financialYear}`);
    return response.data;
};

export const downloadForm16 = async (financialYear, employeeId = null) => {
    const params = { financial_year: financialYear };
    if (employeeId) params.employee_id = employeeId;

    const response = await api.get('/tax/form16/download', {
        params,
        responseType: 'blob'
    });
    return response.data;
};
